import * as angular from 'angular';
import { MailingJobDefinitionDto } from '../../models';
import { MailingJobDefinition } from '../../models/mailing/MailingJobDefinition';
import { IRequestService } from '../request.service';

export interface IMailingJobService {
    add(mailingJobDefinition: any): angular.IPromise<MailingJobDefinitionDto>;
    update(mailingJobDefinition: any): angular.IPromise<MailingJobDefinitionDto>;
    test(mailingJobDefinition: MailingJobDefinition): angular.IPromise<boolean>;
    getAll(force?: boolean): angular.IPromise<MailingJobDefinitionDto[]>;
    getByGuid(guid: string): angular.IPromise<MailingJobDefinitionDto>;
    refresh(guid: string): angular.IPromise<any>;
    deleteByGuid(guid: string): angular.IPromise<void>;
    start(definition): angular.IPromise<void>;
    stop(definition): angular.IPromise<void>;
}

export class MailingJobService implements IMailingJobService {
    static serviceId = 'mailingJobService';

    static $inject = ['$q', 'requestService'];

    constructor(
        private _$q: angular.IQService,
        private _requestService: IRequestService
    ) {
    }

    add(mailingJobDefinition: any): angular.IPromise<MailingJobDefinitionDto> {
        return this._requestService
            .postAtV1<MailingJobDefinitionDto>('mailingJob', mailingJobDefinition)
            .then(data => {
                this._requestService.cleanCacheAtV1(`mailingJob/${data.guid}`);
                this._requestService.cleanCacheAtV1('mailingJob');
                return data;
            });
    }

    update(mailingJobDefinition: any): angular.IPromise<MailingJobDefinitionDto> {
        return this._requestService
            .postAtV1<MailingJobDefinitionDto>('mailingJob/update', mailingJobDefinition)
            .then(data => {
                this._requestService.cleanCacheAtV1(`mailingJob/${mailingJobDefinition.guid}`);
                this._requestService.cleanCacheAtV1('mailingJob');
                return data;
            });
    }

    test(mailingJobDefinition: MailingJobDefinition): angular.IPromise<boolean> {
        return this._requestService.postAtV1('mailingJob/test', mailingJobDefinition);
    }

    getAll(force: boolean = false): angular.IPromise<MailingJobDefinitionDto[]> {
        const url = 'mailingJob';
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1(url);
    }

    getByGuid(guid: string): angular.IPromise<MailingJobDefinitionDto> {
        return this._requestService.getAtV1(`mailingJob/${guid}`);
    }

    refresh(guid: string): angular.IPromise<MailingJobDefinitionDto> {
        this._requestService.cleanCacheAtV1(`mailingJob/${guid}`);
        return this.getByGuid(guid);
    }

    deleteByGuid(guid: string): angular.IPromise<void> {
        const defered = this._$q.defer<void>();
        this._requestService.deleteAtV1('mailingJob', null, { guid: guid })
            .then(() => {
                this._requestService.cleanCacheAtV1(`mailingJob`);
                this._requestService.cleanCacheAtV1(`mailingJob/${guid}`);
                defered.resolve();
            })
            .catch(reason => defered.reject(reason));
        return defered.promise;
    }

    start(definition): angular.IPromise<void> {
        return this._requestService
            .postAtV1<void>('mailingJob/start', definition)
            .then(() => {
                this._requestService.cleanCacheAtV1(`mailingJob`);
                this._requestService.cleanCacheAtV1(`mailingJob/${definition.guid}`);
            });
    }

    stop(definition): angular.IPromise<void> {
        return this._requestService
            .postAtV1<void>('mailingJob/stop', definition)
            .then(() => {
                this._requestService.cleanCacheAtV1(`mailingJob`);
                this._requestService.cleanCacheAtV1(`mailingJob/${definition.guid}`);
            });
    }
}